import { Flex } from "rebass";
import React from "react";
import "react-multi-carousel/lib/styles.css";

const PopupItem = ({ style, image }) => {
  return (
    <Flex
      bg={"white"}
      style={{
        ...style,
        alignItems: "center",
        justifyContent: "center",
        height: "500px",
      }}
    >
      <img
        className="relative"
        alt="product"
        src={image}
        style={{
          pointerEvents: "none",
        }}
      />
    </Flex>
  );
};

export { PopupItem };
